import React, { useContext } from "react";

import { PopUpContext } from "../../contexts/popUpContext";

import EntryYearPopUp from "./EntryYear";
import ToastMessage from "./ToastMessage";
import StudentFeePopUp from "./StudentFee";
import StudentForm from "./StudentForm";
import TeacherBalancePopUp from "./TeacherBalance";
import StaffBalancePopUp from "./StaffBalance";
import StudentBalancePopUp from "./StudentBalance";
import StudentDiscountPopUp from "./StudentDiscount";
import StudentPastBalancePopUp from "./StudentPastBalance";
import TeacherPastBalancePopUp from "./TeacherPastBalance";
import StaffPastBalancePopUp from "./StaffPastBalance";
import TeacherSalaryPaymentPopUp from "./TeacherSalaryPayment";
import StaffSalaryPaymentPopUp from "./StaffSalaryPayment";
import CreditorForm from "./CreditorForm";
import CreditorBalancePopUp from "./CreditorBalance";
import CreditorPastBalancePopUp from "./CreditorPastBalance";
import CreditorDeptPaymentPopUp from "./CreditorDeptPayment";
import CreditorDeptPopUp from "./CreditorDept";
import SubAccountForm from "./SubAccountForm";
import ExpensePopUp from "./ExpenseForm";
import RevenuePopUp from "./RevenueForm";
import ContractorForm from "./ContractorForm";
import ContractorBalance from "./ContractorBalance";
import ContractorPastBalancePopUp from "./ContractorPastBalance";
import ExpenseBudgetForm from "./ExpenseBudgetForm";
import RevenueBudgetForm from "./RevenueBudgetForm";
import ClassForm from "./ClassForm";
import SubjectForm from "./SubjectForm";
import StudentToClass from "./StudentToClass";
import AccessResource from "./AccessResourceForm";
import DeletePopUp from "./DeleteForm";
import DiscountType from "./DiscountTypeForm";
import RevenueSubAccountForm from "./RevenueSubAccountForm";
import ContractorPayableForm from "./ContractorPayableForm";
import StudentPersonalInfoForm from "./StudentPersonalInfoForm";
import StudentDocumentsInfoForm from "./StudentDocumnetsInfoForm";
import StudentEducationalInfoForm from "./StudentEducationalInfoForm";
import StudentClassInfoForm from "./StudentClassInfoForm";
import StudentResultUpdateForm from "./StudentResultUpdateForm";
import UserProfilePopUp from "./UserProfile";
import TeacherBenefitForm from "./TeacherBenefitForm";
import StaffContractForm from "./StaffContractForm";
import StaffForm from "./StaffForm";
import TeacherForm from "./TeacherForm";
import TeacherContractForm from "./TeacherContractForm";

const PopUps = () => {
  const { popUp } = useContext(PopUpContext);

  switch (popUp?.form) {
    case "toast":
      return <ToastMessage />;
    case "delete":
      return <DeletePopUp />;
    case "entry-year-pop-up":
      return <EntryYearPopUp />;
    case "user-profile-pop-up":
      return <UserProfilePopUp />;
    case "student-fee-form":
      return <StudentFeePopUp />;
    case "student-form":
      return <StudentForm />;
    case "student-personal-info-form":
      return <StudentPersonalInfoForm />;
    case "student-documents-info-form":
      return <StudentDocumentsInfoForm />;
    case "student-educational-info-form":
      return <StudentEducationalInfoForm />
    case "student-class-info-form":
      return <StudentClassInfoForm />
    case "student-balance-form":
      return <StudentBalancePopUp />;
    case "student-discount-form":
      return <StudentDiscountPopUp />;
    case "student-past-balance-pop-up":
      return <StudentPastBalancePopUp />;
    case "teacher-form":
      return <TeacherForm />;
    case "teacher-balance-form":
      return <TeacherBalancePopUp />;
    case "teacher-payment-form":
      return <TeacherSalaryPaymentPopUp />;
    case "teacher-contract-form":
      return <TeacherContractForm />;
    case "teacher-past-balance-pop-up":
      return <TeacherPastBalancePopUp />;
    case "teacher-benefit-form":
      return <TeacherBenefitForm />;
    case "staff-form":
      return <StaffForm />;
    case "staff-past-balance-pop-up":
      return <StaffPastBalancePopUp />;
    case "staff-balance-form":
      return <StaffBalancePopUp />;
    case "student-result-update-form":
      return <StudentResultUpdateForm />;
    case "staff-payment-form":
      return <StaffSalaryPaymentPopUp />;
    case "staff-contract-form":
      return <StaffContractForm />;
    case "creditor-form":
      return <CreditorForm />;
    case "creditor-balance-form":
      return <CreditorBalancePopUp />;
    case "creditor-past-balance-pop-up":
      return <CreditorPastBalancePopUp />;
    case "creditor-debt-payment-form":
      return <CreditorDeptPaymentPopUp />;
    case "creditor-debt-form":
      return <CreditorDeptPopUp />;
    case "expense-sub-account-form":
      return <SubAccountForm />;
    case "expense-form":
      return <ExpensePopUp />;
    case "revenue-form":
      return <RevenuePopUp />;
    case "contractor-form":
      return <ContractorForm />;
    case "contractor-balance-form":
      return <ContractorBalance />;
    case "contractor-past-balance-pop-up":
      return <ContractorPastBalancePopUp />;
    case "expense-budget-form":
      return <ExpenseBudgetForm />;
    case "revenue-budget-form":
      return <RevenueBudgetForm />;
    case "class-form":
      return <ClassForm />;
    case "subject-form":
      return <SubjectForm />;
    case "student-to-class":
      return <StudentToClass />;
    case "access-resource":
      return <AccessResource />;
    case "discount-type":
      return <DiscountType />;
    case "revenue-sub-account":
      return <RevenueSubAccountForm />;
    case "contractor-payable-form":
      return <ContractorPayableForm />;
    default:
      return null;
  }
};

export default PopUps;
